// extracted by mini-css-extract-plugin
module.exports = {"container":"Notifications-module__container--1U6nU","list":"Notifications-module__list--D-ZRP","preview":"Notifications-module__preview--qjYj-"};